import CloseIcon from '@assets/images/common/icon/close.svg';
import { COMPANY_URL } from '@src/routes/company';
import Button from '@src/ui/elements/button/Button';
import React from 'react';
import { useNavigate } from 'react-router-dom';

type Props = {
  message: string;
  isVisible: boolean;
  popupRef: React.RefObject<HTMLDivElement>;
  className?: string;
  onClose?: () => void;
};

export default function LoginPromptPopup({ message, isVisible, popupRef, className, onClose }: Props) {
  const navigate = useNavigate();

  if (!isVisible) {
    return null;
  }

  return (
    <div
      ref={popupRef}
      className={`absolute left-1/2 top-full z-50 mt-2 w-[350px] -translate-x-1/2 rounded-md border border-gray-200 bg-white p-3 md:top-4 md:z-[100] md:w-[300px] ${className ?? ''}`}
      data-testid='login-prompt-popup'
    >
      {onClose && (
        <button
          type='button'
          className='absolute right-[8px] top-[8px] grid size-5 place-items-center rounded-full bg-gray-50'
          onClick={onClose}
          aria-label='閉じる'
          data-testid='login-prompt-popup-close'
        >
          <img
            src={CloseIcon}
            alt=''
            width={16}
            height={16}
          />
        </button>
      )}
      <p className='mb-3 break-all text-center text-xs font-medium leading-normal'>{message}</p>
      <div className='flex items-center gap-2'>
        <div className='flex-1'>
          <Button
            size='xs'
            fullRounded
            fullWidth
            onClick={() => {
              window.scrollTo(0, 0);
              navigate(COMPANY_URL.REGISTRATION);
            }}
          >
            新規会員登録
          </Button>
        </div>
        <div className='flex-1'>
          <Button
            size='xs'
            fullRounded
            fullWidth
            outline
            onClick={() => {
              window.scrollTo(0, 0);
              navigate(COMPANY_URL.LOGIN);
            }}
          >
            ログイン
          </Button>
        </div>
      </div>
    </div>
  );
}
